module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "qr-qq.8aec6868.jpg";